import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { ErrorPage } from "@/components/error-page";
import { CopilotCard } from "@/components/index/copilot-card";
import { noIndexSeo } from "@/lib/seo";
import * as m from "@/paraglide/messages";
import { $getLatestThread } from "@/server/actions/thread";

export const Route = createFileRoute("/(app)/chat/")({
	validateSearch: z
		.object({
			redirect: z.string().optional(),
		})
		.optional(),
	beforeLoad: async ({ search }) => {
		const redirectToLatest = search?.redirect === "latest";

		if (redirectToLatest) {
			const result = await $getLatestThread();
			if (result) {
				throw redirect({
					to: "/chat/$threadId",
					params: { threadId: result.threadId },
				});
			}
		}
	},
	component: ChatIndexComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "New Chat | StudyOS",
			description: m.hero_subtitle(),
			pathname: match.pathname,
		}),
	errorComponent: ErrorPage,
});

function ChatIndexComponent() {
	return (
		<div className="flex h-full w-full items-center justify-center px-4 py-10 md:px-12">
			<CopilotCard className="w-full max-w-4xl" />
		</div>
	);
}
